import { Component, OnInit } from '@angular/core';
import {BaseComponent} from '../../shared/components/base.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService } from '../account.service';
import { TranslateService } from '@ngx-translate/core';
import {ErrorType, EnvironmentType} from '../../shared/enums/enums';
import {tap} from 'rxjs';
import {noop} from 'rxjs';
import {LoggerService} from '../../shared/service/logger.service';
import { LoginSuccessResponse } from '../../shared/model/login-success-response';
import {environment} from '../../../../environments/environment';
import { AuthorizationService } from '../../shared/service/authorization.service';
import { ApplicationConfig } from '../../../config/application.config';

@Component({
  selector: 'app-account-confirm',
  templateUrl: './account-confirm.component.html',
  styleUrls: ['./account-confirm.component.scss'],
  providers: [AccountService]
})
export class AccountConfirmComponent extends BaseComponent implements OnInit {

  public sub: any;
  public culture: any;
  public confirmationCode: string;
  public isProccessing: boolean;
  public translationCompleted: boolean = false;
  public confirmSuccess = false;
  public alreadyConfirmed = false;
  public confirmFailed = false;
  public setPassword: boolean;
  public password: string;
  public confirmPassword: string;
  public requiresPrivacyConsent = false;
  public privacyConsentAccepted = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private accountService: AccountService,
    private translate: TranslateService,
    private loggerService: LoggerService,
    private authorizationService: AuthorizationService,
    public applicationConfig: ApplicationConfig) {
      super();
  }

  ngOnInit() {
    this.setPassword = this.route.snapshot.queryParamMap.get('setPassword') == 'true';
    this.requiresPrivacyConsent = this.route.snapshot.queryParamMap.get('product') === 'rental';
    this.password = '';
    this.confirmPassword = '';
    this.isProccessing = false;
    this.sub = this.route.params.subscribe(params => {
      this.culture = params['culture'];
      this.confirmationCode = params['confirmationCode'];

      if (this.culture == null) {
        this.culture == "en-US";
      }

      this.translate.use(this.culture)
        .pipe(
          tap(() => this.translationCompleted = true)
        )
        .subscribe(noop);

        if (!this.setPassword && !this.requiresPrivacyConsent)
        {
          this.confirmAccount();
        }
    });
  }

  public confirmAccount() {
    if (this.requiresPrivacyConsent && !this.privacyConsentAccepted) {
      return;
    }

    this.isProccessing = true;
    var password = this.setPassword ? this.password : null;
    const privacyConsentAccepted = this.requiresPrivacyConsent ? this.privacyConsentAccepted : null;
    this.accountService.confirmAccount(this.confirmationCode, password, privacyConsentAccepted).subscribe(
      response => {
          this.confirmSuccess = true;
          this.isProccessing = false;
          this.onLoginSuccess(response);
        } ,
        e => {
          this.isProccessing = false;
          if(e.error && e.error.code == ErrorType.ACCESSDENIED)
          {
            this.alreadyConfirmed = true;
          }
          else
          {
            this.confirmFailed = true;
            this.loggerService.error(`Failed to confirm account: ${e.message}`);
          }
        }
      );
  }

  private onLoginSuccess(respone: LoginSuccessResponse) {
    if (environment.environmentName === EnvironmentType.LOCAL) {
      this.authorizationService.signInOnLocalEnv(respone);
    } else {
      this.authorizationService.signIn();
    }

    this.router.navigateByUrl('/dashboard');
  }

  goToLoginPage() {
    this.router.navigate(['login'], {relativeTo: this.route.parent});
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  public areBothPasswordEqual(): boolean {
    return this.password === this.confirmPassword;
  }

  public doesPasswordHaveTargetedLenght(): boolean {
    return this.password.length >= this.applicationConfig.MIN_PASSWORD_LENGTH;
  }
}
